export default __webpack_public_path__ + "static/media/workout_tracker_stats_dashboard.65176d9c.png";